export const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_0be0b227-7903-4110-8f0c-b5f35154e6b2/artifacts/pizw8gm3_IMG-20260828-WA0000.jpg";

export const DEFAULT_SETTINGS = {
  id: "site-settings",
  brand_name: "Protech Heating & Cooling",
  descriptor: {
    en: "Heating & cooling that performs when your space counts.",
    es: "Calefacción y aire acondicionado que responde cuando más importa.",
  },
  insurance_statement: { en: "Fully licensed and insured", es: "Totalmente licenciados y asegurados" },
  logo_url: LOGO_URL,
  logo_url_en: LOGO_URL,
  logo_url_es: LOGO_URL,
  phone: "(914)-398-9138",
  email: "protechvac0@gmail.com",
  address: "2025 Albany Post Rd, Croton-on-Hudson, NY 10520",
  service_area: {
    en: "Croton-on-Hudson · Westchester County · New York",
    es: "Croton-on-Hudson · Westchester County · Todo New York",
  },
  hero_kicker: {
    en: "LOCAL HVAC / FIELD-READY SERVICE",
    es: "HVAC LOCAL / SERVICIO LISTO PARA EL CAMPO",
  },
  hero_title: {
    en: "CLIMATE / CONTROL / WITHOUT / COMPROMISE.",
    es: "CLIMA / BAJO CONTROL. / SIN / COMPROMISOS.",
  },
  hero_body: {
    en: "Dependable heating and cooling for homes, businesses, and the spaces that keep New York moving.",
    es: "Calefacción y aire acondicionado confiables para hogares, negocios y los espacios que mantienen a New York en movimiento.",
  },
  hero_primary_label: { en: "Request an estimate", es: "Solicitar cotización" },
  hero_secondary_label: { en: "Call Protech", es: "Llamar a Protech" },
  hero_note: {
    en: "Serving Croton-on-Hudson, Westchester County, and customers across New York.",
    es: "Atendemos Croton-on-Hudson, Westchester County y clientes en todo New York.",
  },
  hero_discount_title: { en: "Hero's Discount", es: "Descuento para Héroes" },
  hero_discount_body: {
    en: "Protech Heating and Cooling offers a Hero's Discount to all who have served and currently serve our country and our community. Simply show your “Hero ID” — badge, membership card, military ID, or similar proof — to receive your discount.",
    es: "Protech Heating and Cooling ofrece un Descuento para Héroes a quienes han servido y a quienes actualmente sirven a nuestro país y nuestra comunidad. Solo muestra tu “Hero ID” — placa, tarjeta de membresía, identificación militar u otra acreditación — para recibir tu descuento.",
  },
  featured_work_title: { en: "Our work, in the field.", es: "Nuestro trabajo, en el campo." },
  featured_work_body: {
    en: "Real installation work, shown as it happens. From water heaters to boilers, every system gets a careful hand and a clear finish.",
    es: "Trabajo real de instalación, mostrado tal como sucede. Desde calentadores de agua hasta calderas, cada sistema recibe cuidado y un resultado claro.",
  },
  featured_video_url: "/protech-field-record.webm",
  featured_video_label: { en: "Water heater, boiler & system installs", es: "Instalaciones de calentadores, calderas y sistemas" },
  images: [
    {
      key: "hero-equipment",
      title: { en: "Engineered for the real world", es: "Diseñado para el mundo real" },
      url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_comfort-systems-web/artifacts/8q1ipqx1_IMG-20260827-WA0129.jpg",
      alt: { en: "Industrial HVAC equipment at a commercial facility", es: "Equipo HVAC industrial en una instalación comercial" },
      visible: true,
    },
    {
      key: "thermal-architecture",
      title: { en: "Built around the whole system", es: "Diseñado alrededor de todo el sistema" },
      url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_comfort-systems-web/artifacts/mt01qnjh_IMG-20260827-WA0130.jpg",
      alt: { en: "Architectural ventilation ductwork", es: "Conductos arquitectónicos de ventilación" },
      visible: true,
    },
    {
      key: "precision-diagnostics",
      title: { en: "Diagnose before we replace", es: "Diagnosticar antes de reemplazar" },
      url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_comfort-systems-web/artifacts/phyuz1nx_IMG-20260827-WA0133.jpg",
      alt: { en: "HVAC technician diagnosing a system", es: "Técnico HVAC diagnosticando un sistema" },
      visible: true,
    },
    {
      key: "extreme-tolerance",
      title: { en: "Ready for the swing", es: "Listo para el cambio" },
      url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_comfort-systems-web/artifacts/i5tjom6o_IMG-20260827-WA0132.jpg",
      alt: { en: "Metal air distribution ducts in a facility", es: "Conductos metálicos de distribución de aire" },
      visible: true,
    },
    {
      key: "dispatch-crew",
      title: { en: "People who show up", es: "Personas que responden" },
      url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_comfort-systems-web/artifacts/pc3dpubk_IMG-20260827-WA0131.jpg",
      alt: { en: "HVAC field crew working on a rooftop system", es: "Equipo HVAC trabajando en un sistema de techo" },
      visible: true,
    },
  ],
};

export const MARQUEE = {
  en: ["HEAT PUMPS", "HYDRONIC HEATING", "COMMERCIAL HVAC", "RAPID DISPATCH", "AIR QUALITY", "PROTECH FIELD SERVICE"],
  es: ["BOMBAS DE CALOR", "CALEFACCIÓN HIDRÓNICA", "HVAC COMERCIAL", "ATENCIÓN RÁPIDA", "CALIDAD DEL AIRE", "SERVICIO PROTECH"],
};

export const MANIFESTO = [
  {
    key: "thermal-architecture",
    number: "01",
    code: "SYSTEM / 01",
    title: { en: "Thermal architecture first.", es: "Primero, la arquitectura térmica." },
    description: {
      en: "We look at the whole building, not just the box on the wall. Airflow, comfort, and the way a space lives have to work together.",
      es: "Miramos el edificio completo, no solo la unidad. El flujo de aire, el confort y la forma en que se vive un espacio deben trabajar juntos.",
    },
    metricLabel: { en: "The point", es: "El objetivo" },
    metricValue: { en: "Balanced air", es: "Aire equilibrado" },
  },
  {
    key: "precision-diagnostics",
    number: "02",
    code: "FIELD / 02",
    title: { en: "Diagnose before we replace.", es: "Diagnosticar antes de reemplazar." },
    description: {
      en: "Clear answers beat guesswork. We trace the problem, explain the fix, and help you make a decision you can stand behind.",
      es: "Las respuestas claras vencen a las suposiciones. Encontramos el problema, explicamos la solución y te ayudamos a decidir con confianza.",
    },
    metricLabel: { en: "The method", es: "El método" },
    metricValue: { en: "Clear answers", es: "Respuestas claras" },
  },
  {
    key: "extreme-tolerance",
    number: "03",
    code: "RANGE / 03",
    title: { en: "Ready for the swing.", es: "Listo para el cambio." },
    description: {
      en: "New York does not do moderate seasons. Your system should feel steady through deep cold, humid heat, and every surprise between them.",
      es: "New York no conoce las temporadas moderadas. Tu sistema debe mantenerse estable con frío intenso, humedad, calor y todo lo que venga entre medio.",
    },
    metricLabel: { en: "The standard", es: "El estándar" },
    metricValue: { en: "All-season", es: "Todo el año" },
  },
  {
    key: "dispatch-crew",
    number: "04",
    code: "PEOPLE / 04",
    title: { en: "People who show up.", es: "Personas que responden." },
    description: {
      en: "Good service is a human promise. We arrive ready to listen, work carefully, and leave your space better than we found it.",
      es: "Un buen servicio es una promesa humana. Llegamos listos para escuchar, trabajar con cuidado y dejar tu espacio mejor que como lo encontramos.",
    },
    metricLabel: { en: "The promise", es: "La promesa" },
    metricValue: { en: "On your side", es: "De tu lado" },
  },
];

export const SERVICES = [
  {
    number: "01",
    icon: "heat",
    title: { en: "Heating systems", es: "Sistemas de calefacción" },
    copy: { en: "Furnaces, heat pumps, and comfort systems built for cold-weather reliability.", es: "Hornos, bombas de calor y sistemas de confort preparados para el frío." },
  },
  {
    number: "02",
    icon: "cool",
    title: { en: "Cooling systems", es: "Sistemas de aire" },
    copy: { en: "Air conditioning that keeps your home or business clear, quiet, and comfortable.", es: "Aire acondicionado que mantiene tu hogar o negocio fresco, silencioso y cómodo." },
  },
  {
    number: "03",
    icon: "commercial",
    title: { en: "Commercial HVAC", es: "HVAC comercial" },
    copy: { en: "Practical climate control for the buildings, teams, and operations that depend on it.", es: "Control climático práctico para edificios, equipos y operaciones que dependen de él." },
  },
  {
    number: "04",
    icon: "air",
    title: { en: "Air quality", es: "Calidad del aire" },
    copy: { en: "Filtration, airflow, and maintenance that make the air inside feel noticeably better.", es: "Filtración, flujo de aire y mantenimiento para que el aire interior se sienta mejor." },
  },
];
